var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.725 16.675C8.925 17.8375 10.35 18.4187 12 18.4187C13.65 18.4187 15.0563 17.8375 16.2188 16.675C17.4188 15.475 18.0188 14.05 18.0188 12.4C18.0188 10.75 17.4188 9.3437 16.2188 8.1812C15.0563 6.9812 13.65 6.3812 12 6.3812C10.35 6.3812 8.925 6.9812 7.725 8.1812C6.5625 9.3437 5.98125 10.75 5.98125 12.4C5.98125 14.05 6.5625 15.475 7.725 16.675ZM8.4 0.418701H15.6L17.7938 2.7812H21.6188C22.2563 2.7812 22.8 3.02495 23.25 3.51245C23.7375 3.99995 23.9813 4.56245 23.9813 5.19995V19.6C23.9813 20.2375 23.7375 20.8 23.25 21.2875C22.8 21.775 22.2563 22.0187 21.6188 22.0187H2.38125C1.74375 22.0187 1.18125 21.775 0.693753 21.2875C0.243753 20.8 0.0187531 20.2375 0.0187531 19.6V5.19995C0.0187531 4.56245 0.243753 3.99995 0.693753 3.51245C1.18125 3.02495 1.74375 2.7812 2.38125 2.7812H6.20625L8.4 0.418701ZM9.3 15.1C8.55 14.35 8.175 13.45 8.175 12.4C8.175 11.35 8.55 10.45 9.3 9.69995C10.05 8.94995 10.95 8.57495 12 8.57495C13.05 8.57495 13.95 8.94995 14.7 9.69995C15.45 10.45 15.825 11.35 15.825 12.4C15.825 13.45 15.45 14.35 14.7 15.1C13.95 15.85 13.05 16.225 12 16.225C10.95 16.225 10.05 15.85 9.3 15.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4297ffabce1c2d0196961a0189951714.svg";
export { ForwardRef as ReactComponent };